import { AgentPromptDocumentTab } from "@/features/agents/agent-prompt-document-tab";
import { AGENT_IDENTITY_PROMPT_KEY } from "@/lib/types/control-plane-agents";

export function AgentIdentityTab() {
  return (
    <AgentPromptDocumentTab
      tabId="identity"
      promptKey={AGENT_IDENTITY_PROMPT_KEY}
      title="IDENTITY.md"
      placeholder="Write the agent identity markdown..."
    />
  );
}
